/*
 * The application main routing module
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes
} from '@angular/router';
import {
  AuthGuard,
  CanChangeClientGuard,
  ContactEmailGuard,
  CannotChangeClientGuard,
  UpdateEmailGuard
} from 'app/shared/guards';
import { PingPreauthComponent } from 'app/features/ping-preauth/ping-preauth.component';
import { FedAuthComponent } from "app/features/fed-auth/fed-auth.component";
import { MfaCallbackComponent } from 'app/features/mfa-callback/mfa-callback.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/home/home.module').then ( m => m.HomeModule ),
    canActivate: [ ContactEmailGuard ]
  }, {
    path: 'home',
    loadChildren: () => import('./features/home/home.module').then ( m => m.HomeModule ),
    canActivate: [ AuthGuard, ContactEmailGuard, CanChangeClientGuard ]
  }, {
    path: 'incident',
    loadChildren: () => import('./features/incident/incident.module').then ( m => m.IncidentModule ),
    canActivate: [ AuthGuard, ContactEmailGuard, CannotChangeClientGuard ]
  }, {
    path: 'update-email',
    loadChildren: () => import('./features/update-email/update-email.module').then ( m => m.UpdateEmailModule ),
    canActivate: [ UpdateEmailGuard ]
  }, {
    path: 'login',
    loadChildren: () => import('./features/login/login.module').then ( m => m.LoginModule )
  }, {
    path: 'auth/mfa/callback',
    component: MfaCallbackComponent,
  }, {
    path: ':urlSegmentKey/login',
    loadChildren: () => import('./features/login/login.module').then ( m => m.LoginModule )
  }, {
    path: 'trueblue',
    redirectTo: 'trueblue/login',
    pathMatch: 'full'
  }, {
    path: 'authenticate',
    loadChildren: () => import('./features/login/login.module').then ( m => m.LoginModule )
  }, {
    path: 'error',
    canActivate: [ CannotChangeClientGuard ],
    loadChildren: () => import('./features/error/error.module').then ( m => m.ErrorModule )
  },{
    path: 'recover',
    loadChildren: () => import('./features/reset-password/reset-password.module').then ( m => m.ResetPasswordModule )
  },{
    path: 'vendor-confirmation',
    loadChildren: () => import('./features/vendor-confirmation/vendor-confirmation.module').then ( m => m.VendorConfirmationModule )
  },
  {
    path: 'ss-validate-vehicle-plate',
    loadChildren: () => import('./features/ss-validate-vehicle-plate/ss-validate-vehicle-plate.module').then ( m => m.SsValidateVehiclePlateModule ),
    canActivate: [ AuthGuard, ContactEmailGuard ]
  },
  {
    path: 'ping-preauth',
    component: PingPreauthComponent,
  },
  {
    path: 'fed-auth',
    component: FedAuthComponent
  },
];

@NgModule ( {
  imports: [ RouterModule.forRoot ( routes, {} ) ],
  exports: [ RouterModule ]
} )
export class AppRoutingModule {}
